import { ref, unref } from 'vue';

export function usePostSaleStatusDeadlineActions({
  initialAction = '',
  openNucleo,
  postSaleCase,
  requestExternal,
}) {
  const agendaAction = ref(initialAction);
  const transitionOpen = ref(Boolean(initialAction));

  const openTransition = (code = '') => {
    agendaAction.value = code;
    transitionOpen.value = true;
    return true;
  };

  const open = action => {
    if (action?.kind === 'external') {
      return requestExternal({ postSaleCase: unref(postSaleCase), action });
    }
    if (action?.kind === 'nucleo') return openNucleo();
    if (action?.kind === 'status') return openTransition(action.code);
    return false;
  };

  const close = () => {
    agendaAction.value = '';
    transitionOpen.value = false;
  };

  return { agendaAction, close, open, openTransition, transitionOpen };
}
